import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { bufferWhen, filter, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { startWith } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {


  outerCSS: Observable<SafeResourceUrl[]>;

  constructor(router: Router, private sanitizer: DomSanitizer,) {

    const end = () => router.events.pipe(
      // tap(a => console.log(a)),
      filter((e) => (e instanceof NavigationEnd)));
    const bread = router.events.pipe(
      // tap(a => console.log(a)),
      filter((e) => e instanceof ActivationEnd),
      map((e) => (e as ActivationEnd).snapshot),
    );

    this.outerCSS = bread.pipe(
      bufferWhen(end),
      map(snaps => _.flatMap(snaps, n => n.data['css'] as string)),
      map(a => _.filter(a, b => b)),
      map(a => _.uniq(a)),
      startWith(['vendor', 'index']),
      map(a => _.map(a, css => this.sanitizer.bypassSecurityTrustResourceUrl(`/css/${css}.css?72fe7685`)))
    );
  }

  ngOnInit(): void {
  }

  pickCSS(a: SafeResourceUrl) {
    return a;
  }

}
